// Deployment trigger: 2026-06-05

export interface DrawResult {
  drawId: string;
  prizeId: string;
  prizeName: string;
}

/**
 * Requests a server-authoritative prize draw. The winner is chosen on the
 * server (so it can't be rigged on the client) and recorded in a `draws` doc
 * that the leads security rule validates. Pass outcome='loss' for skill games
 * (trivia / gift-rain) when the player did not win.
 */
export const drawPrize = async (campaignId: string, outcome?: 'loss'): Promise<DrawResult> => {
  let response: Response;
  try {
    response = await fetch('/api/draw', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ campaignId, outcome }),
    });
  } catch {
    throw new Error('Could not reach the game server. Please try again.');
  }

  let data: any = {};
  try {
    data = await response.json();
  } catch {
    /* non-JSON */
  }

  if (!response.ok || !data.prizeId) {
    throw new Error(data.error || 'Could not start the game. Please try again.');
  }

  return data as DrawResult;
};
